<template>
  <v-container fill-height>
    <v-row no-gutters>
      <v-col
        class="d-flex align-center justify-center"
        cols="12"
        sm="12"
        md="12"
        lg="6"
        xl="6"
      >
        <div class="pa-4">
          <div
            :class="
              $vuetify.breakpoint.mdAndDown
                ? 'error-title-mobile'
                : 'error-title'
            "
          >
            <span>Opa!</span>
          </div>
          <div
            :class="
              $vuetify.breakpoint.mdAndDown
                ? 'pt-5 error-text-mobile'
                : 'pt-5 error-text'
            "
            class="pt-5 error-text"
          >
            <span
              >Não conseguimos encontrar a página que você está buscando.</span
            >
          </div>
          <div
            :class="
              $vuetify.breakpoint.mdAndDown
                ? 'pt-5 error-code-text-mobile'
                : 'pt-5 error-code-text'
            "
          >
            <span>Código do erro: 404</span>
          </div>
          <div class="pt-5">
            <v-btn
              class="back-button"
              height="50"
              color="accent lighten-1"
              @click="goToHome"
            >
              Voltar para a página inicial
            </v-btn>
          </div>
        </div>
      </v-col>
      <v-col
        class="d-flex align-center justify-center"
        cols="12"
        sm="12"
        md="12"
        lg="6"
        xl="6"
        order="first"
        order-sm="first"
        order-md="first"
        order-lg="last"
        order-xl="last"
      >
        <div class="pa-4">
          <div class="rounded-corners-gradient-borders">
            <lottie
              class="rounded-animation"
              :options="alertaDisErrorAnimation"
            />
          </div>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import routes from "@/router/routes";
import Lottie from "@/core/component/lottie.vue";
import errorAnimation from "@/assets/error-animation.json";

export default {
  name: "ResponseError",
  props: ["message", "status"],
  components: {
    Lottie,
  },
  data: () => ({
    alertaDisErrorAnimation: {
      animationData: errorAnimation,
    },
  }),
  methods: {
    goToHome() {
      this.$router.push(routes.monitoring.path).catch(() => {});
    },
  },
};
</script>

<style scoped>
.error-title {
  font-family: "Manrope";
  font-style: normal;
  font-weight: 800;
  font-size: 64px;
  line-height: 87px;
  color: var(--v-primary-base);
}

.error-text {
  font-family: "Manrope";
  font-style: normal;
  font-weight: 500;
  font-size: 32px;
  line-height: 44px;
  color: var(--v-primary-base);
}

.error-code-text {
  font-family: "Manrope";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
  color: var(--v-primary-base);
}
.error-title-mobile {
  font-family: "Manrope";
  font-style: normal;
  font-weight: 800;
  font-size: 32px;
  line-height: 44px;
  color: var(--v-primary-base);
}

.error-text-mobile {
  font-family: "Manrope";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 22px;
  color: var(--v-primary-base);
}

.error-code-text-mobile {
  font-family: "Manrope";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: var(--v-primary-base);
}

.back-button {
  text-transform: none;
  border-radius: 8px;
}

.rounded-animation {
  border-radius: 46px;
}

.rounded-corners-gradient-borders {
  border: double 5px transparent;
  border-radius: 50px;
  background-image: linear-gradient(
      var(--v-secondary-lighten1),
      var(--v-secondary-lighten1)
    ),
    radial-gradient(
      circle at 45px 45px,
      rgba(244, 133, 29, 1),
      rgba(244, 133, 29, 0)
    );
  background-origin: border-box;
  background-clip: padding-box, border-box;
}
</style>